import React from "react";
import { Table, Switch, Button, Image, Avatar, Tag, notification } from "antd";
import {
  agregarPorcentaje,
  formatoMexico,
} from "../../../config/reuserFunction";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import aws from "../../../config/aws";
import clienteAxios from "../../../config/axios";

export default function TablaProductosAdmin({
  productosRender,
  showDeleteConfirm,
  setActualizar,
  setProductoID,
  setReload,
  setLoading,
}) {
  const token = localStorage.getItem("token");

  const PublicarProducto = async (idproducto, publico) => {
    setLoading(true);
    await clienteAxios
      .put(`/productos/publicar/producto/caja/${idproducto}`, {publico: !publico}, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        notification.success({
          message: res.data.message,
          duration: 2,
        });
        setReload(true);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          notification.error({
            message: "Error",
            description: err.response.data.message,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error de conexion",
            description: "Al parecer no se a podido conectar al servidor.",
            duration: 2,
          });
        }
      });
  };

  const columns = [
    {
      title: "Imagen",
      dataIndex: "imagen",
      key: "imagen",
      render: (imagen, data) => (
        <Avatar
          key={data._id}
          size={64}
          className="d-flex justify-content-center align-items-center"
          src={<Image width="100%" src={aws + imagen} />}
        />
      ),
    },
    {
      title: "Producto",
      dataIndex: "nombre",
      key: "nombre",
      render: (producto, data) => (
        <h6 key={data._id} className=" font-weight-bold">
          {producto}
        </h6>
      ),
    },
    {
      title: "Precio",
      dataIndex: "precio",
      key: "precio",
      width: 100,
      render: (precio, data) =>
        data.promocion.length > 0 ? (
          <div key={data._id} className="">
            <h6 className="precio-producto rebajado">
              ${formatoMexico(precio)}
            </h6>
            <h6 className="precio-rebaja d-inline">
              ${formatoMexico(data.promocion[0].precioPromocion)}
            </h6>
          </div>
        ) : (
          <h6 key={data._id}>$ {formatoMexico(precio)}</h6>
        ),
    },
    {
      title: "Descuento",
      dataIndex: "promocion",
      key: "promocion",
      width: 100,
      render: (promocion, data) =>
        promocion.length > 0 ? (
          <h6 key={data._id} className="porcentaje-descuento">
            {agregarPorcentaje(promocion[0].precioPromocion, data.precio)}%OFF
          </h6>
        ) : (
          <h6 key={data._id}>0%</h6>
        ),
    },
    {
      title: "Activo para",
      dataIndex: "socios",
      key: "socios",
      render: (socios, data) =>
        socios ? (
          <Tag key={data._id} color="blue">
            Solo socios
          </Tag>
        ) : (
          <Tag key={data._id} color="green">
            Todos
          </Tag>
        ),
    },
    {
      title: "Público",
      dataIndex: "publico",
      key: "publico",
      width: "90px",
      render: (publico, data) => (
        <Switch
          key={data._id}
          checked={publico}
          checkedChildren="Público"
          unCheckedChildren="Oculto"
          onChange={() => PublicarProducto(data._id, publico)}
        />
      ),
    },
    {
      title: "Editar",
      key: "editar",
      width: "90px",
      render: (_, data) => (
        <Button
          key={data._id}
          type="text"
          className="d-flex justify-content-center align-items-center"
          shape="circle"
          icon={<EditOutlined style={{ fontSize: 22 }} />}
          size="large"
          onClick={() => {
            setActualizar();
            setProductoID(data._id);
          }}
        />
      ),
    },
    {
      title: "Eliminar",
      key: "eliminar",
      width: "90px",
      render: (_, data) => (
        <Button
          key={data._id}
          key={data._id}
          type="text"
          className="d-flex justify-content-center align-items-center"
          shape="circle"
          icon={<DeleteOutlined style={{ fontSize: 22 }} />}
          size="large"
          danger
          onClick={() => showDeleteConfirm(data._id)}
        />
      ),
    },
  ];

  return (
    <Table
      rowKey={(data) => data._id}
      columns={columns}
      dataSource={productosRender}
      pagination={false}
      scroll={{ x: 1000 }}
    />
  );
}
